import { render, staticRenderFns } from "./GoodJoin.vue?vue&type=template&id=00b55817&scoped=true&"
import script from "./GoodJoin.vue?vue&type=script&lang=js&"
export * from "./GoodJoin.vue?vue&type=script&lang=js&"
import style0 from "./GoodJoin.vue?vue&type=style&index=0&id=00b55817&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b55817",
  null
  
)

export default component.exports